export function manualPlayerDraft(item={}) {
  const name=String(item.name || ""),parts=name.trim().match(/^(\S+)(?:\s+([\s\S]*))?$/);
  const firstName=String(item.firstName ?? (parts?.[1] || "")),lastName=String(item.lastName ?? (parts?.[2] || ""));
  return {firstName,lastName,photoReference:item.photoReference || "",jersey:item.jersey || "",graduationYear:item.graduationYear || "",notes:item.notes || "",originalName:name,originalFirstName:firstName,originalLastName:lastName};
}

export function manualPlayerFields(draft) {
  const fields={};
  for(const field of ["photoReference","firstName","lastName","jersey","graduationYear","notes"]){
    const value=String(draft[field] || "").trim(),limit=field==="jersey" ? 40 : ["firstName","lastName"].includes(field) ? 200 : 1000;
    if(value.length>limit)throw new Error("Player fields are too long. Names allow 200 characters, jersey numbers 40, and other fields 1,000.");
    fields[field]=value;
  }
  const unchangedNames=fields.firstName===String(draft.originalFirstName || "").trim() && fields.lastName===String(draft.originalLastName || "").trim();
  fields.name=unchangedNames && draft.originalName ? draft.originalName : [fields.firstName,fields.lastName].filter(Boolean).join(" ");
  if(!fields.name)throw new Error("Enter a first or last name.");
  if(fields.name.length>200)throw new Error("Keep the full player name to 200 characters.");
  return fields;
}
